import vueAPI from '@/modules/vueAPI'

let globalFunctions = {
    tech: {
        getSiteLanguages(myCallback) {
            socket.emit('getSiteLangs', function(allLangs) {
                // console.log(allLangs)
                vueAPI.onMounted((thisVue) => {
                    allLangs.forEach(lang => {
                        if (!thisVue.$store.state.languages.hasOwnProperty(lang.code)) {
                            thisVue.$store.state.languages[lang.code] = lang;
                        }
                    })
                })

                if (typeof myCallback === 'function') {
                    myCallback(allLangs);
                }
            })
        }
    },
    user: {
        me: {
            getMyData(myCallback) {
                socket.emit("getMyData", function(myData) {
                    // console.log(myData)
                    vueAPI.onMounted(function(thisVue) {
                        thisVue.$store.state.myData.profileData = {...thisVue.$store.state.myData.profileData, ...myData}
                    })

                    if (typeof myCallback === "function") {
                        myCallback(myData)
                    }
                })
            }
        }
    }
}

export default globalFunctions;